<template>
  <div class="home-container">
    <!-- 顶部导航栏 -->
    <el-header class="header">
      <div class="header-left">
        <div class="logo">ERP系统</div>
        <el-button 
          type="text" 
          @click="toggleCollapse" 
          class="collapse-btn"
          :icon="isCollapsed ? 'Expand' : 'Fold'"
        />
      </div>
      <el-dropdown class="user-menu">
        <div class="user-info" style="border: none;">
          <el-avatar :size="40" :src="user.avatar" />
          <span class="username">{{ user.nickname }}</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- <el-dropdown-item @click="showEditDialog">修改信息</el-dropdown-item> -->
            <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </el-header>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 左侧菜单 -->
      <el-aside :width="isCollapsed ? '64px' : '200px'" class="sidebar">
          <el-menu
          :router="true"
          :default-active="$route.path"
          :collapse="isCollapsed"
          class="el-menu-vertical"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b">
          <el-menu-item index="/dashboard">
            <el-icon><PieChart /></el-icon>
            <span>数据看板</span>
          </el-menu-item>
          <el-menu-item index="/employee">
            <el-icon><User /></el-icon>
            <span>员工管理</span>
          </el-menu-item>
          <el-menu-item index="/contract">
            <el-icon><Document /></el-icon>
            <span>合同管理</span>
          </el-menu-item>
          <el-menu-item index="/project">
            <el-icon><Briefcase /></el-icon>
            <span>项目管理</span>
          </el-menu-item>
          <el-menu-item index="/driver">
            <el-icon><Van /></el-icon>
            <span>司机管理</span>
          </el-menu-item>
          <el-menu-item index="/department">
            <el-icon><OfficeBuilding /></el-icon>
            <span>部门管理</span>
          </el-menu-item>
          <el-menu-item index="/reimbursement">
            <el-icon><Money /></el-icon>
            <span>报销管理</span>
          </el-menu-item>
          <el-menu-item index="/product">
            <el-icon><Goods /></el-icon>
            <span>产品管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 右侧内容区 -->
      <el-main class="content">
        <router-view />
      </el-main>
    </div>
  </div>
</template>

<script>
import { PieChart, User, Document, Briefcase, Van, OfficeBuilding, Money, Goods, Fold, Expand } from '@element-plus/icons-vue'

export default {
  name: 'HomePage',
  components: {
    PieChart,
    User,
    Document,
    Briefcase,
    Van,
    OfficeBuilding,
    Money,
    Goods,
    Fold,
    Expand
  },
  data() {
    return {
      user: {
        nickname: '未登录',
        avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
      },
      isCollapsed: false
    }
  },
  watch: {
    '$route'(to) {
      // 进入项目详情页面时自动折叠左侧菜单
      if (to.name === 'project-detail') {
        this.isCollapsed = true
      }
    },
    '$store.getters.userInfo': {
      immediate: true,
      handler(newVal) {
        console.log('User info updated:', newVal)
        if (newVal) {
          this.user = newVal
        }
      }
    }
  },
 
  methods: {
    handleLogout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login').catch(() => {})
      })
    },
    showEditDialog() {
      this.$message.info('修改信息功能待实现')
    },
    // Removed handleMenuSelect since we're using router=true now
    
    // 切换菜单折叠状态
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    }
  }
}
</script>

<style scoped>
.home-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #409EFF;
  color: white;
  padding: 0 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.collapse-btn {
  color: white;
  font-size: 18px;
  padding: 8px;
}

.collapse-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.logo {
  font-size: 20px;
  font-weight: bold;
}

.user-menu {
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.username {
  font-size: 16px;
}

.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar {
  background-color: #545c64;
  transition: width 0.3s ease;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.el-menu-vertical.el-menu--collapse {
  width: 64px;
}

.content {
  padding: 20px;
  background-color: #f0f2f5;
}
</style>
